import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

interface Scripts {
  name: string;
  src: string;
}

export const ScriptStore: Scripts[] = [
  {name: 'square', src: environment.ngGtcPaySquare.apiSquare}
];

@Injectable({
  providedIn: 'root'
})
export class ScriptService {
  private scripts: any = {};
  constructor(
    private httpService: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    ScriptStore.forEach((script: any) => {
      this.scripts[script.name] = {
          loaded: false,
          src: script.src
      };
  });
  }
  loadScripts(...scripts: string[]): Promise<any> {
    const promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
}

loadScript(name: string) {
  return new Promise((resolve, reject) => {
      if (!isPlatformBrowser(this.platformId)) {
          resolve({script: name, loaded: false, status: 'SSR'});
          return;
      }
      if (!this.scripts[name].loaded) {
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = this.scripts[name].src;
          // @ts-ignore
          if (script.readyState) {  // IE
              // @ts-ignore
              script.onreadystatechange = () => {
                  // @ts-ignore
                  if (script.readyState === 'loaded' || script.readyState === 'complete') {
                      // @ts-ignore
                      script.onreadystatechange = null;
                      this.scripts[name].loaded = true;
                      resolve({script: name, loaded: true, status: 'Loaded'});
                  }
              };
          } else {  // Others
              script.onload = () => {
                    this.scripts[name].loaded = true;
                  resolve({script: name, loaded: true, status: 'Loaded'});
              };
          }
          script.onerror = (error: any) => resolve({script: name, loaded: false, status: 'Loaded'});
          document.getElementsByTagName('head')[0].appendChild(script); // <--- !!!
      } else {
          resolve({script: name, loaded: true, status: 'Already Loaded'});
      }
  });
}

isAlreadyLoaded(name:any): boolean {
  return this.scripts[name]?.loaded;
}

}

